import type { Template } from "@/types";

export const PO_07_H0_V7: Template[] = [
{
    id: "po-07-h0v7-01",
    name: "PO 01 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 0, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 },
            { id: "2", x: 175, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 350, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 },
            { id: "4", x: 525, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 },
            { id: "6", x: 875, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1050, y: 290, width: 167, height: 272, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h0v7-02",
    name: "PO 02 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_02.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 62, y: 177, width: 157, height: 245, rotation: 0, imageRotation: 0 },
        { id: "2", x: 227, y: 177, width: 156, height: 245, rotation: 0, imageRotation: 0 },
        { id: "3", x: 391, y: 177, width: 156, height: 245, rotation: 0, imageRotation: 0 },
        { id: "4", x: 62, y: 430, width: 157, height: 245, rotation: 0, imageRotation: 0 },
        { id: "5", x: 227, y: 430, width: 156, height: 245, rotation: 0, imageRotation: 0 },
        { id: "6", x: 391, y: 430, width: 156, height: 245, rotation: 0, imageRotation: 0 },
        { id: "7", x: 753, y: 177, width: 320, height: 496, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-03",
    name: "PO 03 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 138, y: 94, width: 163, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 94, width: 163, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 138, y: 318, width: 163, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 309, y: 318, width: 163, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 138, y: 543, width: 163, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 309, y: 543, width: 163, height: 215, rotation: 0, imageRotation: 0 },
            { id: "7", x: 707, y: 94, width: 412, height: 663, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-04",
    name: "PO 04 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 37, y: 0, width: 535, height: 851, rotation: 0, imageRotation: 0 },
        { id: "2", x: 652, y: 148, width: 169, height: 274, rotation: 0, imageRotation: 0 },
        { id: "3", x: 829, y: 148, width: 169, height: 274, rotation: 0, imageRotation: 0 },
        { id: "4", x: 1006, y: 148, width: 168, height: 274, rotation: 0, imageRotation: 0 },
        { id: "5", x: 652, y: 430, width: 169, height: 273, rotation: 0, imageRotation: 0 },
        { id: "6", x: 829, y: 430, width: 169, height: 273, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1006, y: 430, width: 168, height: 273, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-05",
    name: "PO 05 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 48, y: 225, width: 253, height: 400, rotation: 0, imageRotation: 0 },
        { id: "2", x: 309, y: 225, width: 122, height: 196, rotation: 0, imageRotation: 0 },
        { id: "3", x: 439, y: 225, width: 122, height: 196, rotation: 0, imageRotation: 0 },
        { id: "4", x: 309, y: 429, width: 122, height: 196, rotation: 0, imageRotation: 0 },
        { id: "5", x: 439, y: 429, width: 122, height: 196, rotation: 0, imageRotation: 0 },
        { id: "6", x: 656, y: 225, width: 253, height: 400, rotation: 0, imageRotation: 0 },
        { id: "7", x: 917, y: 225, width: 252, height: 400, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-06",
    name: "PO 06 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 57, y: 162, width: 390, height: 529, rotation: 0, imageRotation: 0 },
        { id: "2", x: 455, y: 162, width: 109, height: 171, rotation: 0, imageRotation: 0 },
        { id: "3", x: 455, y: 341, width: 109, height: 171, rotation: 0, imageRotation: 0 },
        { id: "4", x: 455, y: 521, width: 109, height: 170, rotation: 0, imageRotation: 0 },
        { id: "5", x: 654, y: 162, width: 335, height: 529, rotation: 0, imageRotation: 0 },
        { id: "6", x: 997, y: 162, width: 165, height: 261, rotation: 0, imageRotation: 0 },
        { id: "7", x: 997, y: 431, width: 165, height: 260, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-07",
    name: "PO 07 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_07.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 60, y: 83, width: 214, height: 340, rotation: 0, imageRotation: 0 },
        { id: "2", x: 282, y: 83, width: 214, height: 340, rotation: 0, imageRotation: 0 },
        { id: "3", x: 60, y: 431, width: 214, height: 339, rotation: 0, imageRotation: 0 },
        { id: "4", x: 282, y: 431, width: 214, height: 339, rotation: 0, imageRotation: 0 },
        { id: "5", x: 504, y: 83, width: 431, height: 687, rotation: 0, imageRotation: 0 },
        { id: "6", x: 944, y: 83, width: 214, height: 340, rotation: 0, imageRotation: 0 },
        { id: "7", x: 944, y: 431, width: 214, height: 339, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-08",
    name: "PO 08 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_08.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 71, y: 90, width: 209, height: 332, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 90, width: 209, height: 332, rotation: 0, imageRotation: 0 },
        { id: "3", x: 505, y: 90, width: 209, height: 332, rotation: 0, imageRotation: 0 },
        { id: "4", x: 71, y: 430, width: 209, height: 332, rotation: 0, imageRotation: 0 },
        { id: "5", x: 288, y: 430, width: 209, height: 332, rotation: 0, imageRotation: 0 },
        { id: "6", x: 505, y: 430, width: 209, height: 332, rotation: 0, imageRotation: 0 },
        { id: "7", x: 722, y: 90, width: 423, height: 672, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-09",
    name: "PO 09 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_09.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 61, y: 83, width: 215, height: 340, rotation: 0, imageRotation: 0 },
        { id: "2", x: 61, y: 431, width: 215, height: 339, rotation: 0, imageRotation: 0 },
        { id: "3", x: 284, y: 83, width: 431, height: 687, rotation: 0, imageRotation: 0 },
        { id: "4", x: 723, y: 83, width: 214, height: 340, rotation: 0, imageRotation: 0 },
        { id: "5", x: 723, y: 431, width: 214, height: 339, rotation: 0, imageRotation: 0 },
        { id: "6", x: 945, y: 83, width: 213, height: 340, rotation: 0, imageRotation: 0 },
        { id: "7", x: 945, y: 431, width: 213, height: 339, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-10",
    name: "PO 10 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 207, width: 144, height: 215, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 430, width: 144, height: 214, rotation: 0, imageRotation: 0 },
        { id: "3", x: 152, y: 207, width: 144, height: 215, rotation: 0, imageRotation: 0 },
        { id: "4", x: 152, y: 430, width: 144, height: 214, rotation: 0, imageRotation: 0 },
        { id: "5", x: 304, y: 207, width: 299, height: 437, rotation: 0, imageRotation: 0 },
        { id: "6", x: 611, y: 207, width: 299, height: 437, rotation: 0, imageRotation: 0 },
        { id: "7", x: 918, y: 207, width: 299, height: 437, rotation: 0, imageRotation: 0 }
    ],
}
];